import { FieldType } from '@wix/wix-data-schema-types'
import {
  DROPDOWN_ROLE,
  DROPDOWN_OPTIONS_ROLE,
  USER_INPUT_FILTER_V1_ROLE,
  USER_INPUT_FILTER_DROPDOWN_ROLE,
  GenericRole,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { text, number, reference, stringArray } = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Dropdown',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  compactErrorPanel: false,
  panel: {
    height: 436,
    title: 'Connect_Panel_Title_Dropdown',
    helpId: 'ab559ee7-1d56-4530-b93c-f5b2e4bc8b51',
    chooseScreenHelpId: '55a1880f-bb80-426e-8301-5548900da22e',
    submitContentHelpId: '79ad42a0-9ed9-41d0-b438-002cecc26b12',
    userInputFilterHelpId: 'b07a5366-99e4-43d6-a4e0-49e7afd39394',
  },
  sections: [
    {
      role: DROPDOWN_ROLE,
      genericRole: GenericRole.INPUT_VALUE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Value_Label',
          prop: 'value',
          supportedFieldTypes: [text, number, reference],
          defaultFieldType: text,
          isInputProperty: true,
        },
      ],
    },
    {
      role: DROPDOWN_OPTIONS_ROLE,
      genericRole: GenericRole.INPUT_VALUE_OPTIONS,
      bindings: [
        {
          title: 'Connect_Panel_Connect_List_Options_Values_Label',
          prop: 'value',
          supportedFieldTypes: [text, number],
          defaultFieldType: text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId:
                'dropdown_options_live_preview_gfpp_desktop_main_action',
              label: 'Dropdown_Options_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
    },
    {
      role: USER_INPUT_FILTER_V1_ROLE,
      componentTypeName:
        'Connect_Panel_Dataset_Filter_Message_Element_Type_Dropdown',
      bindings: [],
    },
    {
      role: USER_INPUT_FILTER_DROPDOWN_ROLE,
      isUserInputFilter: true,
      bindings: [
        {
          prop: 'value',
          supportedFieldTypes: [text, number, stringArray, reference],
          defaultFieldType: text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId:
                'user_input_filters_live_preview_gfpp_desktop_main_action',
              label: 'User_Input_Filters_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
        panel: {
          settings: {
            controls: {
              errorMessageFormat: {
                hidden: true,
              },
              initialTextItem: {
                hidden: true,
              },
              required: {
                hidden: true,
              },
            },
          },
        },
      },
    },
  ],
})
